import { AuthURL } from "./AuthURL";
import GuestPageWrapper from "../../components/page_wrappers/GuestPageWrapper";

import LoginPage from "../../pages/auth_pages/LoginPage";
import RegistrationPage from "../../pages/auth_pages/RegistrationPage";
import ForgotPasswordPage from "../../pages/auth_pages/ForgotPasswordPage";
import SetNewPasswordPage from "../../pages/auth_pages/SetNewPasswordPage";

const routeConfigs = [
    { path: AuthURL.LOGIN, component: LoginPage },
    { path: AuthURL.REGISTRATION, component: RegistrationPage },
    { path: AuthURL.FORGOT_PASSWORD, component: ForgotPasswordPage },
    { path: AuthURL.SET_NEW_PASSWORD, component: SetNewPasswordPage },
];

const AuthRoutes = routeConfigs.map(
    route => ({
        path: route.path,
        element: <>
            <GuestPageWrapper>
                <route.component />
            </GuestPageWrapper>
        </>
    })
);

export default AuthRoutes;
